// extracted by mini-css-extract-plugin
export default {"container":"companyShow_container__zLV6d","tableCard":"companyShow_tableCard__12y8S","showCurrency":"companyShow_showCurrency__8s0G9"};